/**
 * FikoTakvim — Üretim Takvimi / Termin Planı motoru
 * İş listesi (parça×adet×birim süre) + kapasite (tezgâh, vardiya) → toplam süre, iş günü, teslim tarihi.
 */

export interface TakvimIs { ad: string; adet: number; birimDk: number; }

export interface TakvimGirdi {
  isler: TakvimIs[];
  tezgahSayisi: number;   // paralel çalışan tezgâh/istasyon
  vardiyaSaat: number;    // günlük çalışma saati (tezgâh başına)
  verimYuzde: number;     // OEE/verim % (duruş/kurulum payı)
}

export interface TakvimSonuc {
  toplamDk: number;          // ham toplam işlem süresi
  efektifDk: number;         // verim düzeltmeli
  toplamSaat: number;
  gunlukKapasiteSaat: number;
  isGunu: number;            // tam iş günü (yukarı yuvarlanmış)
  isGunuKesir: number;       // ondalık
}

export function takvimHesapla(g: TakvimGirdi): TakvimSonuc {
  const toplamDk = (g.isler || []).reduce((t, i) => t + (+i.adet || 0) * (+i.birimDk || 0), 0);
  const verim = Math.max(1, Math.min(100, g.verimYuzde || 100));
  const efektifDk = toplamDk / (verim / 100);
  const toplamSaat = efektifDk / 60;
  const gunlukKapasiteSaat = Math.max(0.1, (g.tezgahSayisi || 1) * (g.vardiyaSaat || 8));
  const isGunuKesir = toplamSaat / gunlukKapasiteSaat;
  return { toplamDk, efektifDk, toplamSaat, gunlukKapasiteSaat, isGunu: Math.ceil(isGunuKesir), isGunuKesir };
}

/** Başlangıç tarihine N iş günü ekle (hafta sonu atlanır) → teslim tarihi. */
export function isGunuEkle(baslangic: Date, isGunu: number): Date {
  const d = new Date(baslangic.getTime());
  let kalan = Math.max(0, Math.ceil(isGunu));
  while (kalan > 0) {
    d.setDate(d.getDate() + 1);
    const gun = d.getDay();   // 0=pazar, 6=cumartesi
    if (gun !== 0 && gun !== 6) kalan--;
  }
  return d;
}
